import React from "react";

type IconBadgeSize = "xs" | "sm" | "md" | "lg" | "xl";
type IconBadgeVariant = "square" | "circle";
type PhosphorWeight = "thin" | "light" | "regular" | "bold" | "fill" | "duotone";

interface IconBadgeProps {
  icon: React.ElementType;
  size?: IconBadgeSize;
  color?: string;
  bg?: string;
  weight?: PhosphorWeight;
  variant?: IconBadgeVariant;
  style?: React.CSSProperties;
}

const SIZE_MAP: Record<IconBadgeSize, { container: number; icon: number; radius: number }> = {
  xs: { container: 28, icon: 15, radius: 6 },
  sm: { container: 36, icon: 18, radius: 8 },
  md: { container: 46, icon: 22, radius: 10 },
  lg: { container: 56, icon: 28, radius: 12 },
  xl: { container: 72, icon: 36, radius: 14 },
};

const IconBadge: React.FC<IconBadgeProps> = ({
  icon: IconComponent,
  size = "md",
  color = "#2e873d",
  bg,
  weight = "regular",
  variant = "square",
  style,
}) => {
  const s = SIZE_MAP[size];
  const background = bg || `${color}14`;
  const borderColor = `${color}30`;

  return (
    <div
      style={{
        width: s.container,
        height: s.container,
        borderRadius: variant === "circle" ? "50%" : s.radius,
        background,
        border: `1px solid ${borderColor}`,
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...style,
      }}
    >
      <IconComponent size={s.icon} weight={weight} color={color} />
    </div>
  );
};

export default IconBadge;
